import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function CaseHotelPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 md:pt-32 pb-10 md:pb-16 bg-premium-navy relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 border-2 border-premium-gold/20 rounded-full -mr-48 -mt-48"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 border-2 border-premium-gold/20 rounded-full -ml-36 -mb-36"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 border border-premium-gold/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6 md:mb-8">
            <Link
              to="/#cases"
              className="inline-flex items-center gap-2 text-premium-gold hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span className="text-sm font-medium">Назад к кейсам</span>
            </Link>

            <div className="inline-block bg-premium-gold text-premium-navy px-4 py-1.5 md:px-5 md:py-2 rounded-full text-sm md:text-base font-bold shadow-lg whitespace-nowrap">
              Кейс по Контекстной Рекламе
            </div>
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-5xl font-display font-bold text-white mb-3 md:mb-4 leading-tight">
            Как получить 1,2 млн ₽ выручки<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>при бюджете 210 тыс. ₽
          </h1>
          <p className="text-premium-gold/80 text-base md:text-xl mt-2 mb-8 md:mb-10">
            Гостиничный бизнес (B2C) • Дизайн-отель «Стандарт» 5* • Москва, 10 минут от Кремля
          </p>

          {/* Key stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {[
              { icon: 'ri-money-dollar-circle-line', label: 'Рекламный бюджет', value: '210 170 ₽' },
              { icon: 'ri-trophy-line', label: 'Выручка', value: '1 245 668 ₽' },
              { icon: 'ri-percent-line', label: 'ROMI', value: '492,7%' },
              { icon: 'ri-calendar-check-line', label: 'Конверсии', value: '1 462 шт' },
            ].map((stat, i) => (
              <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-5 text-center border border-premium-gold/20 hover:border-premium-gold/40 transition-all duration-300">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center mx-auto mb-1 md:mb-2">
                  <i className={`${stat.icon} text-xl md:text-2xl text-premium-gold`}></i>
                </div>
                <div className="text-lg md:text-2xl font-display font-bold text-white">{stat.value}</div>
                <div className="text-premium-gold/80 text-xs md:text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-10 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          {/* Challenge */}
          <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16">
            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg border-2 border-gray-100 hover:border-premium-gold transition-all duration-300">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 md:w-10 md:h-10 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-hotel-line text-lg md:text-xl text-premium-gold"></i>
                </div>
                <h3 className="text-lg md:text-xl font-display font-bold text-slate-900">Клиент</h3>
              </div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-14 h-14 md:w-16 md:h-16 flex-shrink-0 rounded-xl overflow-hidden border-2 border-premium-gold/30 bg-slate-900 flex items-center justify-center">
                  <img
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/e673ad2e775e2bfaddc6d20134e70e84.jpeg"
                    alt="Логотип дизайн-отеля Стандарт"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-gray-700 text-sm font-semibold">Дизайн-отель «Стандарт» 5*</p>
              </div>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-premium-gold mt-0.5 flex-shrink-0"></i>
                  <span>Москва, 10 минут от Кремля</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-star-line text-premium-gold mt-0.5 flex-shrink-0"></i>
                  <span>Премиум-сегмент</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-user-line text-premium-gold mt-0.5 flex-shrink-0"></i>
                  <span>B2C (прямые бронирования)</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg border-2 border-gray-100 hover:border-premium-gold transition-all duration-300">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 md:w-10 md:h-10 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-line text-lg md:text-xl text-premium-gold"></i>
                </div>
                <h3 className="text-lg md:text-xl font-display font-bold text-slate-900">Период</h3>
              </div>
              <div className="text-center mt-4">
                <div className="text-lg md:text-2xl font-display font-bold text-premium-gold mb-2">Июль 2021 — Июнь 2022</div>
                <p className="text-gray-600 text-sm">Оптимизация рекламных кампаний</p>
                <p className="text-xs text-gray-500 mt-2">Data-Driven подход</p>
              </div>
            </div>

            <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg border-2 border-gray-100 hover:border-premium-gold transition-all duration-300">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 md:w-10 md:h-10 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-off-line text-lg md:text-xl text-premium-gold"></i>
                </div>
                <h3 className="text-lg md:text-xl font-display font-bold text-slate-900">Точка А</h3>
              </div>
              <p className="text-gray-700 text-sm font-semibold mb-3">«Слепая» реклама</p>
              <p className="text-gray-600 text-sm leading-relaxed mb-3 text-justify">
                На сайте отеля работал модуль бронирования, но данные о деньгах не передавались в аналитику корректно.
              </p>
              <div className="space-y-2 text-sm text-gray-600">
                <p className="text-justify"><strong>Боль:</strong> Клиент видел расходы, но не видел реального дохода с каждого объявления.</p>
                <p className="text-justify"><strong>Риск:</strong> Бюджет сливался на ключевые слова, которые приносили клики, но не видно было оплат.</p>
              </div>
            </div>
          </div>

          {/* Solution */}
          <div className="bg-premium-navy rounded-xl md:rounded-2xl p-6 md:p-12 text-white mb-10 md:mb-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border border-premium-gold/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border border-premium-gold/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-display font-bold mb-3 md:mb-4 text-center">
                ⚙️ Системное решение (Data-Driven подход)
              </h2>
              <p className="text-base md:text-xl text-premium-gold/80 text-center mb-6 md:mb-10">
                Мы не стали просто «менять креативы». Мы пошли путём цифр и экономики.
              </p>

              <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-5 md:p-6 border-2 border-premium-gold/30 hover:border-premium-gold transition-all duration-300">
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-line-chart-line text-xl md:text-2xl text-premium-navy"></i>
                    </div>
                    <div>
                      <h4 className="text-base md:text-lg font-display font-bold mb-2">1. Настройка сквозной аналитики</h4>
                      <ul className="space-y-1 text-sm text-premium-gold/80">
                        <li>• Внедрили новый модуль бронирования</li>
                        <li>• Настроили корректную передачу данных о транзакциях напрямую в Яндекс.Метрику</li>
                        <li className="text-justify">• <strong className="text-premium-gold">Результат:</strong> Реклама стала «прозрачной». Мы увидели, сколько денег приносит каждый потраченный рубль.</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-5 md:p-6 border-2 border-premium-gold/30 hover:border-premium-gold transition-all duration-300">
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-money-dollar-circle-line text-xl md:text-2xl text-premium-navy"></i>
                    </div>
                    <div>
                      <h4 className="text-base md:text-lg font-display font-bold mb-2">2. Оптимизация по деньгам, а не по кликам</h4>
                      <ul className="space-y-1 text-sm text-premium-gold/80">
                        <li className="text-justify">• Отключили фразы, которые «ели» бюджет, но не давали броней</li>
                        <li className="text-justify">• Масштабировали ставки на ключевых словах, приносящих реальные оплаты</li>
                        <li className="text-justify">• Переписали объявления, добавив продающие триггеры, выявленные через анализ UTM-меток</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Traffic Analysis Screenshot */}
          <div className="mb-10 md:mb-16">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-display font-bold text-slate-900 mb-3 md:mb-4 text-center">
              📊 Анализ рекламного трафика
            </h2>
            <p className="text-center text-gray-600 mb-6 md:mb-10 text-sm md:text-lg">
              Детальная аналитика переходов по UTM-меткам показывает эффективность каждого канала.<br />
              <span className="text-premium-gold font-semibold">Статистика на сентябрь 2021.</span>
            </p>

            <div className="bg-premium-pearl rounded-xl md:rounded-2xl p-4 md:p-6 shadow-lg border-2 border-premium-gold/30">
              <div className="mb-4 md:mb-6">
                <div className="bg-white rounded-xl overflow-hidden shadow-md border-2 border-premium-gold/20">
                  <img
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/0910c563b628409fcfeac5136ce23f99.png"
                    alt="Аналитика переходов по рекламе — UTM-метки кампаний"
                    className="w-full h-auto object-top"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-4 md:mb-6">
                <div className="bg-white rounded-xl p-3 md:p-5 shadow-md text-center border-2 border-premium-gold/30">
                  <span className="inline-block bg-premium-gold text-premium-navy px-2 py-0.5 rounded-full text-xs font-bold mb-2">
                    Всего переходов
                  </span>
                  <div className="text-2xl md:text-4xl font-display font-bold text-premium-gold">151</div>
                  <p className="text-gray-500 text-xs mt-1">по рекламным кампаниям</p>
                </div>

                <div className="bg-premium-navy rounded-xl p-3 md:p-5 text-white shadow-md text-center border-2 border-premium-gold/30">
                  <span className="inline-block bg-premium-gold/20 rounded-full text-xs font-bold px-2 py-0.5 mb-2">
                    Google Ads
                  </span>
                  <div className="text-2xl md:text-4xl font-display font-bold text-premium-gold">101</div>
                  <p className="text-premium-gold/70 text-xs mt-1">переход (66,9%)</p>
                </div>

                <div className="bg-premium-navy rounded-xl p-3 md:p-5 text-white shadow-md text-center border-2 border-premium-gold/30">
                  <span className="inline-block bg-premium-gold/20 rounded-full text-xs font-bold px-2 py-0.5 mb-2">
                    Яндекс Директ
                  </span>
                  <div className="text-2xl md:text-4xl font-display font-bold text-premium-gold">50</div>
                  <p className="text-premium-gold/70 text-xs mt-1">переходов (33,1%)</p>
                </div>

                <div className="bg-white rounded-xl p-3 md:p-5 shadow-md text-center border-2 border-premium-gold/20">
                  <span className="inline-block bg-premium-gold/20 text-premium-navy rounded-full text-xs font-bold px-2 py-0.5 mb-2">
                    Глубина просмотра
                  </span>
                  <div className="text-2xl md:text-4xl font-display font-bold text-premium-gold">1,79</div>
                  <p className="text-gray-500 text-xs mt-1 leading-relaxed">
                    Для сайта отеля это отличный показатель — пользователю достаточно времени для принятия решения.
                  </p>
                </div>
              </div>

              <div className="bg-white border-2 border-premium-gold/30 rounded-xl p-4 md:p-5">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-9 h-9 md:w-10 md:h-10 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-line text-lg md:text-xl text-premium-navy"></i>
                  </div>
                  <div>
                    <h5 className="font-display font-bold text-slate-900 mb-2">💡 Что показывают данные?</h5>
                    <div className="space-y-2 text-sm text-gray-700">
                      <p className="text-justify">
                        <strong>UTM-метки кампаний:</strong> Благодаря правильной настройке UTM-меток мы видим точное распределение трафика между Google Ads и Яндекс Директ.
                      </p>
                      <p className="text-justify">
                        <strong>151 переход по рекламе:</strong> 101 переход через Google Ads (66,9%) и 50 через Яндекс Директ (33,1%). Это позволяет оптимизировать бюджет между каналами.
                      </p>
                      <p className="text-justify">
                        <strong>Глубина просмотра 1,79:</strong> Пользователи не просто кликают и уходят — они изучают сайт, смотрят номера, читают условия. Это качественный трафик, готовый к конверсии.
                      </p>
                      <p className="text-premium-gold font-semibold mt-2 text-justify">
                        🎯 Результат: Мы видим не просто клики, а реальное поведение пользователей, что позволяет точно управлять рекламным бюджетом.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Booking Module Block */}
          <div className="mb-10 md:mb-16">
            <div className="bg-premium-pearl rounded-xl md:rounded-2xl p-6 md:p-12 border-2 border-premium-gold/30">
              <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-xl md:text-2xl text-premium-gold"></i>
                </div>
                <h2 className="text-lg md:text-2xl font-display font-bold text-slate-900">
                  Встроенный модуль бронирования
                </h2>
              </div>

              <div className="bg-white rounded-xl shadow-md border-2 border-premium-gold/20 mb-6 md:mb-8">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d01f4233567112f5ab1e733359054b64.png"
                  alt="Встроенный модуль бронирования на сайте отеля"
                  className="w-full h-auto rounded-xl"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6">
                <div className="bg-white rounded-xl p-4 md:p-5 border-2 border-red-100">
                  <div className="flex items-start gap-3 mb-2">
                    <div className="w-8 h-8 bg-red-50 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-error-warning-line text-red-400 text-lg"></i>
                    </div>
                    <h4 className="font-display font-bold text-slate-900">До июня 2022</h4>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed text-justify pl-11">
                    Ранее на сайте отеля был настроен модуль бронирования, но передача данных о доходах в систему аналитики была настроена некорректно, из-за этого возникало много спорных вопросов об эффективности рекламных кампаний, клиент не видел реальных доходов.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-4 md:p-5 border-2 border-premium-gold/30">
                  <div className="flex items-start gap-3 mb-2">
                    <div className="w-8 h-8 bg-premium-gold/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-line text-premium-gold text-lg"></i>
                    </div>
                    <h4 className="font-display font-bold text-slate-900">С июня 2022</h4>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed text-justify pl-11">
                    На сайте отеля появился встроенный модуль бронирования, с помощью которого передача данных о покупках в систему аналитики стала доступной.
                  </p>
                </div>
              </div>

              <div className="bg-premium-navy rounded-xl p-4 md:p-5 border-2 border-premium-gold/30">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-lightbulb-line text-premium-navy text-lg"></i>
                  </div>
                  <p className="text-premium-gold/90 text-sm leading-relaxed text-justify">
                    <strong className="text-premium-gold">Итог:</strong> Это стало переломным моментом — реклама перестала быть «чёрным ящиком», и каждая потраченная копейка начала отображаться в реальных доходах.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* UTM Optimization Block */}
          <div className="mb-10 md:mb-16">
            <div className="bg-premium-navy rounded-xl md:rounded-2xl p-6 md:p-12 border-2 border-premium-gold/30 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-56 h-56 border border-premium-gold/10 rounded-full -mr-28 -mt-28"></div>
              <div className="absolute bottom-0 left-0 w-40 h-40 border border-premium-gold/10 rounded-full -ml-20 -mb-20"></div>

              <div className="relative z-10">
                <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-eye-line text-xl md:text-2xl text-premium-navy"></i>
                  </div>
                  <h2 className="text-lg md:text-2xl font-display font-bold text-white">
                    Оптимизация на основе UTM-данных
                  </h2>
                </div>

                <p className="text-premium-gold/90 text-sm md:text-base leading-relaxed text-justify">
                  На основании отчёта по UTM меткам мы проанализировали ключевые слова и объявления, которые приносили больший доход. Добавили формулировки продающих заголовков и оптимизировали ставки по ключевым словам, которые привели к продажам.
                </p>

                <div className="mt-5 md:mt-6 rounded-xl overflow-hidden border-2 border-premium-gold/30">
                  <img
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/9347e763d18681095ceab3ae975c547e.png"
                    alt="Анализ ключевых слов и UTM-меток по рекламным кампаниям"
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Website Visibility Block */}
          <div className="mb-10 md:mb-16">
            <div className="bg-premium-pearl rounded-xl md:rounded-2xl p-6 md:p-12 border-2 border-premium-gold/30">
              <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-xl md:text-2xl text-premium-gold"></i>
                </div>
                <h2 className="text-lg md:text-2xl font-display font-bold text-slate-900">
                  Видимость веб-сайта «Стандарт» отель в интернете
                </h2>
              </div>

              <div className="bg-white rounded-xl shadow-md border-2 border-premium-gold/20 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/1bc4a9bb7ff7c7241d90eeedc5d8175e.jpeg"
                  alt="Видимость сайта дизайн-отеля Стандарт в поисковой системе Яндекс"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>

          {/* Ad Display and Visibility Block */}
          <div className="mb-10 md:mb-16">
            <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-12 border-2 border-premium-gold/30">
              <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-line text-xl md:text-2xl text-premium-gold"></i>
                </div>
                <h2 className="text-lg md:text-2xl font-display font-bold text-slate-900">
                  Показ и видимость рекламы
                </h2>
              </div>

              <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                {/* Large photo on the left */}
                <div className="w-full rounded-xl overflow-hidden border-2 border-premium-gold/20">
                  <img
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/1e1af2c53936e8fdeb0662f69cf47849.png"
                    alt="Показ рекламы дизайн-отеля Стандарт в поисковой выдаче Яндекс"
                    className="w-full h-auto"
                  />
                </div>

                {/* Two smaller horizontal photos on the right */}
                <div className="flex flex-col gap-4 md:gap-6">
                  <div className="w-full rounded-xl overflow-hidden border-2 border-premium-gold/20">
                    <img
                      src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/e739c7a8666cd12b077f411cf1158fe5.jpeg"
                      alt="Реклама дизайн-отеля Стандарт в поисковой выдаче Яндекс"
                      className="w-full h-auto"
                    />
                  </div>
                  <div className="w-full rounded-xl overflow-hidden border-2 border-premium-gold/20">
                    <img
                      src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/8b9a4513e8b8dfd6732e5aec377cc153.jpeg"
                      alt="Онлайн-бронирование отеля — видимость рекламы в интернете"
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* E-commerce Optimization Insight Block */}
          <div className="mb-10 md:mb-16">
            <div className="bg-premium-pearl rounded-xl md:rounded-2xl p-6 md:p-12 border-2 border-premium-gold/30">
              <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-navy rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-bar-chart-grouped-line text-xl md:text-2xl text-premium-gold"></i>
                </div>
                <h2 className="text-lg md:text-2xl font-display font-bold text-slate-900">
                  Оптимизация по фактическим данным электронной коммерции
                </h2>
              </div>

              <div className="bg-white rounded-xl shadow-md border-2 border-premium-gold/20 overflow-hidden mb-6 md:mb-8">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/e199e07955e2ccf5e13ad07a3b1a57d6.jpeg"
                  alt="Отчёт Яндекс.Метрики по источникам трафика и доходам от электронной коммерции"
                  className="w-full h-auto"
                />
              </div>

              <div className="bg-white rounded-xl p-5 md:p-6 border-2 border-premium-gold/20 mb-5 md:mb-6">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed text-justify">
                  Такой высокий результат мы смогли достигнуть благодаря оптимизации по фактическим данным из источников электронной коммерции, так как оптимизировали кампании не по конверсиям на сайте, а по <strong>реальному доходу бронирования</strong> в каждой рекламной кампании.
                </p>
              </div>

              <div className="bg-premium-navy rounded-xl p-5 md:p-6 border-2 border-premium-gold/30">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-9 h-9 md:w-10 md:h-10 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-lightbulb-line text-lg md:text-xl text-premium-navy"></i>
                  </div>
                  <div>
                    <h4 className="text-premium-gold font-display font-bold text-base md:text-lg mb-2">Вывод</h4>
                    <p className="text-premium-gold/90 text-sm leading-relaxed text-justify">
                      Грамотно настроенная отчётность в системах веб-аналитики ответит на самые важные вопросы владельцев бизнеса и аналитиков.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Financial Results */}
          <div className="mb-10 md:mb-16">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-display font-bold text-slate-900 mb-3 md:mb-4 text-center">
              📊 Финансовые результаты (Точка Б)
            </h2>
            <p className="text-center text-gray-600 mb-6 md:mb-10 text-sm md:text-lg">
              Благодаря переходу от «настройки кликов» к «управлению рентабельностью», мы вышли на сверхвысокую окупаемость
            </p>

            {/* Budget vs Revenue */}
            <div className="grid grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-10">
              <div className="bg-premium-navy rounded-xl md:rounded-2xl p-5 md:p-8 text-white shadow-xl text-center border-2 border-premium-gold/30">
                <div className="text-xs md:text-sm font-medium mb-1 md:mb-2 opacity-90">Рекламный бюджет</div>
                <div className="text-2xl md:text-5xl font-display font-bold mb-1 md:mb-2 text-premium-gold">210 170 ₽</div>
                <div className="text-sm md:text-lg opacity-90">Инвестиции в рекламу</div>
              </div>

              <div className="bg-premium-gold rounded-xl md:rounded-2xl p-5 md:p-8 text-premium-navy shadow-xl text-center border-2 border-premium-navy/10">
                <div className="text-xs md:text-sm font-medium mb-1 md:mb-2 opacity-90">Полученная выручка</div>
                <div className="text-2xl md:text-5xl font-display font-bold mb-1 md:mb-2">1 245 668 ₽</div>
                <div className="text-sm md:text-lg opacity-90">Реальный доход</div>
              </div>
            </div>

            {/* ROMI Visualization */}
            <div className="bg-premium-navy rounded-xl md:rounded-2xl p-6 md:p-8 shadow-xl mb-6 md:mb-8 border-2 border-premium-gold/30 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-48 h-48 border border-premium-gold/10 rounded-full -mr-24 -mt-24"></div>
              <div className="absolute bottom-0 left-0 w-40 h-40 border border-premium-gold/10 rounded-full -ml-20 -mb-20"></div>
              
              <div className="relative z-10">
                <h3 className="text-lg md:text-2xl font-display font-bold text-white mb-3 md:mb-4 text-center">
                  🔥 ROMI (Возврат инвестиций): <span className="text-premium-gold">492,7%</span>
                </h3>
                <p className="text-center text-premium-gold/80 mb-6 md:mb-8 text-sm md:text-base">
                  На каждый вложенный 1 рубль клиент получил почти 5 рублей выручки
                </p>

                {/* Bar Chart */}
                <div className="mb-6 md:mb-8">
                  <div className="relative pt-12 flex items-end justify-center gap-6 md:gap-16" style={{ height: '220px' }}>
                    <div className="flex-1 flex flex-col items-center min-w-0">
                      <div className="w-full relative" style={{ height: '160px' }}>
                        <div
                          className="absolute bottom-0 w-full bg-gradient-to-t from-premium-navy/80 to-premium-navy/60 rounded-t-xl border-2 border-premium-gold/30"
                          style={{ height: '20%' }}
                        >
                          <div className="absolute -top-9 left-1/2 transform -translate-x-1/2 bg-premium-navy border-2 border-premium-gold text-premium-gold px-1.5 md:px-4 py-1 md:py-2 rounded-xl text-[10px] md:text-sm font-bold whitespace-nowrap shadow-xl">
                            210 170 ₽
                          </div>
                        </div>
                      </div>
                      <div className="text-xs md:text-lg text-premium-gold font-bold mt-3">Расходы</div>
                    </div>

                    <div className="flex-1 flex flex-col items-center min-w-0">
                      <div className="w-full relative" style={{ height: '160px' }}>
                        <div
                          className="absolute bottom-0 w-full bg-gradient-to-t from-premium-gold via-premium-gold/90 to-premium-gold/80 rounded-t-xl shadow-2xl shadow-premium-gold/50 border-2 border-premium-gold"
                          style={{ height: '100%' }}
                        >
                          <div className="absolute -top-9 left-1/2 transform -translate-x-1/2 bg-premium-gold text-premium-navy px-1.5 md:px-4 py-1 md:py-2 rounded-xl text-[10px] md:text-sm font-bold whitespace-nowrap shadow-xl scale-110">
                            1 245 668 ₽
                          </div>
                        </div>
                      </div>
                      <div className="text-xs md:text-lg text-premium-gold font-bold mt-3">Доходы</div>
                    </div>
                  </div>
                </div>

                {/* Money Multiplication */}
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 mb-4 md:mb-6 border border-premium-gold/30">
                  <div className="flex items-center justify-center gap-3 md:gap-4 flex-wrap">
                    <div className="flex items-center gap-2">
                      <div className="w-12 h-12 md:w-16 md:h-16 bg-premium-navy border-2 border-premium-gold rounded-full flex items-center justify-center shadow-lg">
                        <i className="ri-money-dollar-circle-line text-2xl md:text-3xl text-premium-gold"></i>
                      </div>
                      <span className="text-xl md:text-2xl font-display font-bold text-white">1 ₽</span>
                    </div>

                    <i className="ri-arrow-right-line text-2xl md:text-3xl text-premium-gold"></i>

                    <div className="flex items-center gap-1 md:gap-2 flex-wrap justify-center">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <div
                          key={i}
                          className="w-9 h-9 md:w-12 md:h-12 bg-premium-gold rounded-full flex items-center justify-center shadow-lg animate-pulse"
                          style={{ animationDelay: `${i * 0.1}s` }}
                        >
                          <i className="ri-money-dollar-circle-line text-base md:text-xl text-premium-navy"></i>
                        </div>
                      ))}
                      <span className="text-xl md:text-2xl font-display font-bold text-premium-gold ml-1 md:ml-2">≈ 5 ₽</span>
                    </div>
                  </div>
                  <p className="text-center text-white mt-3 md:mt-4 text-sm md:text-base font-semibold">
                    Каждый вложенный рубль превращается в 5 рублей выручки
                  </p>
                </div>

                {/* Additional Metrics */}
                <div className="grid grid-cols-2 gap-3 md:gap-4">
                  <div className="bg-premium-pearl rounded-xl p-3 md:p-5 text-center border-2 border-premium-gold/30">
                    <div className="text-xs md:text-sm text-gray-600 mb-1">Стоимость брони (CPA)</div>
                    <div className="text-xl md:text-3xl font-display font-bold text-premium-gold">143,75 ₽</div>
                    <div className="text-xs text-gray-500 mt-1">Очень низкая стоимость привлечения</div>
                  </div>
                  <div className="bg-premium-pearl rounded-xl p-3 md:p-5 text-center border-2 border-premium-gold/30">
                    <div className="text-xs md:text-sm text-gray-600 mb-1">Конверсии</div>
                    <div className="text-xl md:text-3xl font-display font-bold text-premium-gold">1 462 шт</div>
                    <div className="text-xs text-gray-500 mt-1">Успешных бронирований</div>
                  </div>
                </div>

                {/* Extra metrics row */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mt-3 md:mt-4">
                  <div className="bg-premium-pearl rounded-xl p-3 md:p-5 text-center border-2 border-premium-gold/30">
                    <div className="text-xs md:text-sm text-gray-600 mb-1">Средняя цена клика</div>
                    <div className="text-xl md:text-3xl font-display font-bold text-premium-gold">15,56 ₽</div>
                    <div className="text-xs text-gray-500 mt-1">Средний CPC по кампаниям</div>
                  </div>
                  <div className="bg-premium-pearl rounded-xl p-3 md:p-5 text-center border-2 border-premium-gold/30">
                    <div className="text-xs md:text-sm text-gray-600 mb-1">Количество показов</div>
                    <div className="text-xl md:text-3xl font-display font-bold text-premium-gold">913 752</div>
                    <div className="text-xs text-gray-500 mt-1">Суммарно по всем кампаниям</div>
                  </div>
                  <div className="bg-premium-pearl rounded-xl p-3 md:p-5 text-center border-2 border-premium-gold/30">
                    <div className="text-xs md:text-sm text-gray-600 mb-1">Количество кликов</div>
                    <div className="text-xl md:text-3xl font-display font-bold text-premium-gold">13 508</div>
                    <div className="text-xs text-gray-500 mt-1">Целевые переходы на сайт</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Key Achievement */}
            <div className="bg-premium-navy border-2 border-premium-gold/30 rounded-xl md:rounded-2xl p-6 md:p-8">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-premium-gold rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-xl md:text-2xl text-premium-navy"></i>
                </div>
                <div>
                  <h3 className="font-display font-bold text-white mb-2 md:mb-3 text-lg md:text-xl">💡 Вывод</h3>
                  <div className="space-y-2 text-sm text-premium-gold/80">
                    <p className="text-justify">
                      <strong className="text-premium-gold">Грамотно настроенная аналитика превращает рекламу из «расходов» в управляемый инструмент печати денег.</strong>
                    </p>
                    <p className="text-justify">
                      На каждый вложенный 1 рубль клиент получил почти 5 рублей выручки.
                    </p>
                    <p className="text-premium-gold font-semibold text-justify">
                      Это не магия, а результат системного подхода: сквозная аналитика + управление по реальному ROI, а не по кликам.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center py-10 md:py-12 bg-premium-navy rounded-2xl md:rounded-3xl border-2 border-premium-gold/30 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border border-premium-gold/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border border-premium-gold/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10 px-4">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-display font-bold text-white mb-3 md:mb-4">
                Хотите знать, сколько прибыли приносит ваша реклама?
              </h2>
              <p className="text-premium-gold/80 text-sm md:text-lg mb-6 md:mb-8 max-w-2xl mx-auto text-center">
                Настроим аналитику и отключим неэффективные расходы. Закажите аудит рекламного кабинета.
              </p>
              <Link
                to="/#lead-form"
                className="block w-full sm:w-auto sm:inline-block bg-premium-gold text-premium-navy px-6 py-3 md:px-10 md:py-5 rounded-full text-sm sm:text-base md:text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 sm:whitespace-nowrap cursor-pointer text-center"
              >
                Заказать аудит рекламного кабинета
              </Link>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}
